import React from 'react'
import MemberSelectPanel from './MemberSelectPanel'
import SelectField from './SelectField'
import type { OpenPanel, ScheduleJobMember } from './types'
import type { ScheduleJobDialogClasses } from './useScheduleJobDialogStyles'

interface MemberSelectionProps {
  classes: ScheduleJobDialogClasses
  members: ScheduleJobMember[]
  selectedMemberIds: Set<string>
  openPanel: OpenPanel
  onOpenPanelChange: (panel: OpenPanel) => void
  onMemberToggle: (id: string) => void
  onMembersClear: () => void
}

export default function MemberSelection(props: MemberSelectionProps) {
  const memberCount = props.selectedMemberIds.size
  const label = memberCount > 0 ? `${memberCount} selected` : null

  return (
    <div className={props.classes.fieldGroup}>
      <span className={props.classes.fieldLabel}>Crew Members</span>
      <SelectField
        classes={props.classes}
        active={props.openPanel === 'members'}
        placeholder="Select members"
        value={label}
        onToggle={() => props.onOpenPanelChange(props.openPanel === 'members' ? 'none' : 'members')}
      />
      {props.openPanel === 'members' && (
        <MemberSelectPanel
          classes={props.classes}
          members={props.members}
          selectedMemberIds={props.selectedMemberIds}
          onToggle={props.onMemberToggle}
          onClear={props.onMembersClear}
          onDone={() => props.onOpenPanelChange('none')}
        />
      )}
    </div>
  )
}
